var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelCalendar14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5 9v2H3.997c-.55 0-.997-.453-.997-.997V9zm6 0v1.003c0 .55-.453.997-.997.997H9V9zM8 9v2H6V9zM5 6v2H3V6zm6 0v2H9V6zM8 6v2H6V6zm2.003-3c.55 0 .997.453.997.997V5H3V3.997c0-.55.453-.997.997-.997z"
}))));
export default SvgChannelCalendar14;